import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchProjectService } from '../../service/search/search-project.service';
import { SearchWorkerService } from '../../service/search/search-worker.service';
import { MailInfo } from '../../model/mail-info.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-focus-star',
  templateUrl: './user-focus-star.component.html',
  styleUrls: ['./user-focus-star.component.scss']
})
export class UserFocusStarComponent implements OnInit, OnDestroy {
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  @Input() page: string;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private searchProjectService: SearchProjectService,
    private searchWorkerService: SearchWorkerService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  clickStar(e): void {
    e.stopPropagation();
    if (this.mailType === 'project') {
      this.projectStar();
    } else {
      this.workerStar();
    }
  }

  private projectStar(): void {
    const focus_info = {
      focus_id: this.mailInfo.id,
      focus_side: 'project',
      page: this.page
    };
    this.changeUserFocusStar();
    const projectStarSub = this.searchProjectService.createOrDeleteFocusMail(focus_info).subscribe(
      res => {},
      err => {
        this.changeUserFocusStar();
      }
    );
    this.subscriptions.add(projectStarSub);
  }

  private workerStar(): void {
    const focus_info = {
      focus_id: this.mailInfo.id,
      focus_side: 'worker',
      page: this.page
    };
    this.changeUserFocusStar();
    const workerStarSub = this.searchWorkerService.createOrDeleteFocusMail(focus_info).subscribe(
      res => {},
      err => {
        this.changeUserFocusStar();
      }
    );
    this.subscriptions.add(workerStarSub);
  }

  // 注力スターの色の変更処理
  private changeUserFocusStar(): void {
    this.mailInfo.user_focus = !this.mailInfo.user_focus;
  }
}
